import { render, staticRenderFns } from "./AdminCuerpoPage.vue?vue&type=template&id=1e92215a&"
import script from "./AdminCuerpoPage.vue?vue&type=script&lang=js&"
export * from "./AdminCuerpoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports